import jsPDF from 'jspdf';
import 'jspdf-autotable';
import HTTPRequest from '../../../controllers/httpRequest';
import secureStorage from '../../../controllers/secureStorage.js';
import moment from 'moment';
import { mapState } from 'vuex';
import { decrypt } from "../../../utilities.js"

var printReccsr = {
    computed: {
        ...mapState(['profileId']),
    },
    methods: {
        async printRECCSR(isDefaultPrint, customFont, summaryData) {
            this.spinning = true;
            var totalLineAmount = 0;
            var totalLineDiscountAmount = 0;

            let tabulatorInstance = this.$refs.tabulator.getInstance();
            let tableData = tabulatorInstance.getData();
            let documentDetails = this.documentDetails;

            console.log(`Printing RECCSR with isDefaultPrint=${isDefaultPrint} and customFont=${customFont} and this ${this}`, this);
            // console.log(this.documentDetails, this);

            const doc = new jsPDF('p', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const documentDate = moment(documentDetails.document_date, 'YYYY-MM-DD');
            const postingDate = documentDetails.posting_date

            let xLeftKey = 35;
            let xRightKey = 560;
            let requestingSiteId = this.documentDetails.site_id.key;
            let finalY = 0;

            let siteData = await HTTPRequest.getRequest(`${this.endPoint}sites/${requestingSiteId}`, null, null);
            let companyData = await HTTPRequest.getRequest(`${this.endPoint}companies/${siteData.company_id}`, null, null);
            let b2b = await HTTPRequest.getRequest(`${this.endPoint}b2b_customers/${this.b2bCustomer}`, null, null);
            var documentHistory = await HTTPRequest.getRequest(this.endPoint + "document_action_histories/" + documentDetails.id + "?field_name=document_id", null);
            let isPrinted = false;
            for (let i = 0; i < documentHistory.length; i++) {
                if (documentHistory[i].action === "Print Document") {
                    isPrinted = true;
                    break;
                }
            }
            function addHeader(doc, companyData, siteData, documentDetails, xLeftKey, xRightKey, pageWidth, pageNumber, pageCount) {
                doc.setFontSize(12);
                doc.setFontStyle("bold");
                doc.text(`${String(siteData.company_name).toUpperCase()}`, xLeftKey, 30);

                doc.setFontSize(7);
                doc.setFontStyle("normal");
                let companyAddress = doc.splitTextToSize(`${companyData.address || ''}`, 250);
                doc.text(companyAddress, xLeftKey, 40);
                doc.text(`VAT REG TIN: ${companyData.tin || ''}`, xLeftKey, 60);
                doc.text(`TEL. NO.: ${companyData.telephone || ''}`, xLeftKey, 70);
                doc.text(`FAX NO.: ${companyData.fax || ''}`, xLeftKey, 80);

                doc.setFontSize(7);
                doc.setFontStyle("normal");
                doc.text(`PAGE ${pageNumber}/${pageCount}`, 596, 30, { align: 'right' });
                doc.setFontSize(11);
                doc.setFontStyle("bold");
                doc.text('SALES CREDIT MEMO', xRightKey, 45, { align: 'right' });
                doc.setFontSize(10);
                doc.setFontStyle("bold");
                doc.text(`${documentDetails.cas_no || ""}`, xRightKey, 60, { align: 'right' });
                doc.setFontSize(7);
                doc.setFontStyle("normal");
                doc.text(`${isPrinted ? 'REPRINTED' : 'ORIGINAL'}  COPY`, xRightKey, 75, { align: 'right' });
            }

            // generate the first serial number from the prefix
            function generateFirstSerialNumber(casNo) {
                // split the cas_no to extract the prefix and current serial number
                const parts = casNo.split("-");
                const prefix = parts.slice(0, -1).join("-");
                const firstSerialNumber = `${prefix}-99999999`;
                return firstSerialNumber;
            }

            const currentSerialNumber = documentDetails.cas_no || "";
            const firstSerialNumber = generateFirstSerialNumber(currentSerialNumber);

            function addFooter(doc, pageWidth, pageHeight) {
                const currentDate = moment().format('MM/DD/YYYY');
                const currentTime = moment().format('HH:mm');
                var userName = secureStorage.getItem("userName");

                doc.setFontSize(7);
                doc.setFontStyle("normal");
                doc.text(`Acknowledgement Certificate: ${companyData.cas_permit_number}`, 40, pageHeight - 50);
                doc.text(`Date Issued: ${moment(companyData.acknowledgement_receipt_date_issue).format("MMMM D, YYYY")}`, 40, pageHeight - 35);
                //doc.text(`Serial Number Range: ${currentSerialNumber + ' - ' + firstSerialNumber || ''}`, 40, pageHeight - 20);
                doc.text(`Serial Number Range: ${'CM' + '-' + documentDetails.company_code + '-' + companyData.series_number_range.split('-')[0] + ' - ' + 'CM' + '-' + documentDetails.company_code + '-' + companyData.series_number_range.split('-')[1]}`, 40, pageHeight - 20);
                doc.text(`${documentDetails.status}`, pageWidth - 40, pageHeight - 50, { align: 'right' });
                doc.text(`${userName}`, pageWidth - 40, pageHeight - 35, { align: 'right' });
                doc.text(`${currentDate} ${currentTime}`, pageWidth - 40, pageHeight - 20, { align: 'right' });
            }

            const totalPagesExp = "{total_pages}";
            addHeader(doc, companyData, siteData, documentDetails, xLeftKey, xRightKey, pageWidth, 1, totalPagesExp);

            const wrapTextToWidth = (text, maxWidth) => {
                const str = String(text == null ? '' : text);
                if (!str) return [''];
                const lines = [];
                let current = '';
                for (const char of str) {
                    const candidate = current + char;
                    if (doc.getTextWidth(candidate) > maxWidth && current !== '') {
                        lines.push(current);
                        current = char;
                    } else {
                        current = candidate;
                    }
                }
                if (current !== '') lines.push(current);
                return lines.length ? lines : [''];
            };

            // company info left
            const leftInfoTitleX = 35;
            const leftInfoContentX = 170;
            const leftInfoTextWidth = 150;
            const lineSpacingLeftSide = 20;

            doc.setFontSize(7);
            doc.setFontStyle("bold");
            doc.text('Bill-to Customer Name:', leftInfoTitleX, 100);
            doc.text('VAT Registration No.', leftInfoTitleX, 100 + lineSpacingLeftSide);
            doc.text('Credit Memo No.', leftInfoTitleX, 100 + 2 * lineSpacingLeftSide);
            doc.text('Posting Date', leftInfoTitleX, 100 + 3 * lineSpacingLeftSide);
            doc.text('Document Date', leftInfoTitleX, 100 + 4 * lineSpacingLeftSide);
            doc.text('Prices Including VAT', leftInfoTitleX, 100 + 5 * lineSpacingLeftSide);
            doc.text('Remarks', leftInfoTitleX, 100 + 6 * lineSpacingLeftSide);

            doc.setFontStyle("normal");
            doc.text(decrypt(b2b.name) || "", leftInfoContentX, 100); // as per primer's requirement
            let vatRegistrationNo = doc.splitTextToSize(decrypt(b2b.tin) || "", leftInfoTextWidth);
            doc.text(vatRegistrationNo, leftInfoContentX, 100 + lineSpacingLeftSide);
            doc.text(`${documentDetails.cas_no || ""}`, leftInfoContentX, 100 + 2 * lineSpacingLeftSide);
            doc.text(postingDate, leftInfoContentX, 100 + 3 * lineSpacingLeftSide);
            doc.text(documentDate.format('MM/DD/YYYY'), leftInfoContentX, 100 + 4 * lineSpacingLeftSide);
            doc.text(`${documentDetails.is_prices_including_vat || ""}`, leftInfoContentX, 100 + 5 * lineSpacingLeftSide);
            const remarksY = 100 + 6 * lineSpacingLeftSide;
            const remarksLines = wrapTextToWidth(documentDetails.remark, pageWidth - leftInfoContentX - 30);
            doc.text(remarksLines, leftInfoContentX, remarksY);
            const remarksBottomY = remarksY + remarksLines.length * 8;
            const tableStartY = Math.max(230, remarksBottomY + 12);

            const tableColumn = [
                { header: 'No.', dataKey: 'barcode', styles: { cellWidth: 50, halign: 'right' } },
                { header: 'Description', dataKey: 'product_name', styles: { cellWidth: 150, halign: 'left' } },
                { header: 'Quantity', dataKey: 'quantity', styles: { cellWidth: 65, halign: 'right' } },
                { header: 'Posted Return Receipt Date', dataKey: 'posting_date', styles: { cellWidth: 65, halign: 'left' } },
                { header: 'Unit of Measure', dataKey: 'unit_name', styles: { cellWidth: 65, halign: 'left' } },
                { header: 'Unit Price', dataKey: 'price', styles: { cellWidth: 65, halign: 'right' } },
                { header: 'Line Discount', dataKey: 'discount', styles: { cellWidth: 35, halign: 'right' } },
                { header: 'VAT Identifier', dataKey: 'vat_identifier', styles: { cellWidth: 50, halign: 'left' } },
                { header: 'Amount', dataKey: 'subtotal', styles: { cellWidth: 65, halign: 'right' } },
            ];

            function extractValues(data, keys) {
                let totalAmount = 0;
                let vatableSales = summaryData.net_amount
                let vatExemptSales = '0.00'
                let zeroRated = '0.00'
                let vatAmount = '0.00'
                let vatIdentifier = ''

                if (documentDetails.party_tax_type == 'V') {
                    vatableSales = summaryData.vatables
                    vatAmount = summaryData.vat_amount
                    vatIdentifier = 'Vat 12'
                } else if (documentDetails.party_tax_type == 'X') {
                    vatExemptSales = summaryData.net_amount
                    vatIdentifier = 'Vat EX'
                } else if (documentDetails.party_tax_type == 'Z') {
                    zeroRated = summaryData.net_amount
                    vatIdentifier = 'Vat 0'
                }

                const extractedRows = data.map(row => {
                    const newRow = {};
                    keys.forEach(column => {
                        if (row.hasOwnProperty(column.dataKey)) {
                            if (['price', 'subtotal', 'discount'].includes(column.dataKey)) {
                                // format amount of money w/ commas and w/ 2 decimal places
                                const formattedValue = parseFloat(row[column.dataKey]).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                                newRow[column.dataKey] = formattedValue;
                                // accumulate total for subtotal column
                                if (column.dataKey === 'subtotal') {
                                    let subTotalValue = (Number(row['price']) * Number(row['quantity'])) - Number(row['discount']);
                                    newRow[column.dataKey] = parseFloat(subTotalValue).toLocaleString(undefined, {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    });

                                    totalAmount += subTotalValue;
                                    totalLineAmount += subTotalValue;
                                }
                                if (column.dataKey === 'discount') {
                                    totalLineDiscountAmount += parseFloat(row[column.dataKey]);
                                }
                            } else if (column.dataKey === 'quantity') {
                                // format quantity as a whole number
                                newRow[column.dataKey] = Math.round(parseFloat(row[column.dataKey]));
                            } else if (column.dataKey === 'vat_identifier') {
                                // format quantity as a whole number
                                newRow[column.dataKey] = vatIdentifier.toUpperCase();
                            }
                            else {
                                newRow[column.dataKey] = row[column.dataKey];
                            }

                        }
                    });
                    return newRow;
                });
                let subtotal = Number(totalAmount)
                // add total rowww
                const totalRow = [
                    {
                        barcode: '',
                        product_name: '',
                        quantity: '',
                        document_date: '',
                        unit_name: '',
                        price: '',
                        discount: '',
                        vat_identifier: { content: 'Sub Total', styles: { fontStyle: 'bold', halign: 'right' } },
                        percent_vat: {
                            content: parseFloat(subtotal).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }), styles: { fontStyle: 'bold' }
                        },
                    },
                    {
                        barcode: '',
                        product_name: '',
                        quantity: '',
                        document_date: '',
                        unit_name: '',
                        price: '',
                        discount: '',
                        vat_identifier: { content: 'Less: Invoice Discount', styles: { fontStyle: 'normal', halign: 'right' } },
                        percent_vat: {
                            content: parseFloat(Number(documentDetails.amount_header_discount) + Number(documentDetails.trade_discount)).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }), styles: { fontStyle: 'normal' }
                        },
                    },
                    {
                        barcode: '',
                        product_name: '',
                        quantity: '',
                        document_date: '',
                        unit_name: '',
                        price: '',
                        discount: '',
                        vat_identifier: { content: 'Total PHP Incl. VAT', styles: { fontStyle: 'bold', halign: 'right' } },
                        total_php_excl_vat: {
                            content: parseFloat(summaryData.net_amount).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }), styles: { fontStyle: 'bold' }
                        },
                    },
                    {
                        barcode: '',
                        product_name: '',
                        quantity: '',
                        document_date: '',
                        unit_name: '',
                        price: '',
                        discount: '',
                        vat_identifier: { content: '12% VAT', styles: { fontStyle: 'normal', halign: 'right' } },
                        percent_vat: {
                            content: parseFloat(vatAmount).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }), styles: { fontStyle: 'normal' }
                        },
                    },
                    {
                        barcode: '',
                        product_name: '',
                        quantity: '',
                        document_date: '',
                        unit_name: '',
                        price: '',
                        discount: '',
                        vat_identifier: { content: 'Total PHP Excl. VAT', styles: { fontStyle: 'bold', halign: 'right' } },
                        total_php_incl_vat: {
                            content: parseFloat(summaryData.net_amount_wo_tax).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }), styles: { fontStyle: 'bold' }
                        },
                    }
                ];

                extractedRows.push(...totalRow); // add the total row to the extracted data

                return extractedRows;
            }

            const extractedData = extractValues(tableData, tableColumn);

            const cellsToUnderline = [
                { row: extractedData.length - 3, column: 8, type: 'single' },
                { row: extractedData.length - 1, column: 8, type: 'single' }
            ];

            // while (extractedData.length < 18) {
            //     extractedData.push({ barcode: '', product_name: '', quantity: '', document_date: '', unit_name: '', price: '', discount: '', subtotal: '', vat_identifier: '' });
            // }

            doc.autoTable({
                theme: 'plain',
                head: [tableColumn.map(col => col.header)],
                body: extractedData.map(row => Object.values(row)),
                startY: tableStartY,
                styles: { fontSize: 7 },
                margin: { left: 35, right: 35, top: 100, bottom: 58 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: {
                    0: { halign: 'right' },
                    1: { halign: 'left' },
                    2: { halign: 'right' },
                    3: { halign: 'left' },
                    4: { halign: 'left' },
                    5: { halign: 'right' },
                    6: { halign: 'right' },
                    7: { halign: 'right' },
                    8: { halign: 'right' },
                },
                tableLineColor: [0, 0, 0],
                tableLineWidth: 1,
                pageBreak: 'auto',

                didParseCell: function (data) {
                    const { row, column } = data;
                    const actualRowIndex = row.index;

                    if (column.index === 0) {
                        data.cell.styles.halign = 'left';
                        data.cell.styles.cellWidth = 80;
                    } else if (column.index === 2 || column.index === 4) {
                        data.cell.styles.cellWidth = 40;
                    } else if (column.index === 3) {
                        data.cell.styles.cellWidth = 45;
                    } else if (column.index === 1) {
                        data.cell.styles.halign = 'left';
                        data.cell.styles.cellWidth = 115;
                    }


                    // check if this cell needs underlining
                    const cellToUnderline = cellsToUnderline.find(
                        cell => cell.row === actualRowIndex && cell.column === column.index
                    );

                    if (cellToUnderline) {
                        data.cell.styles.underline = cellToUnderline.type;
                    }
                },

                didDrawCell: function (data) {
                    if (data.cell.styles.underline) {
                        const { x, y, width } = data.cell;
                        doc.setDrawColor(0);
                        doc.setLineWidth(1.2);

                        if (data.cell.styles.underline === 'single') {
                            // draw a single line above the cell
                            doc.line(x, y - 2, x + width, y - 2);
                        }
                    }
                    // draw separation line above the 'Total' row
                    const { column, row, cell } = data;

                    if (row.section = 'body') {
                        const isSubTotalRow = row.raw[7].content === 'Sub Total';
                        if (isSubTotalRow && column.index >= 0 && column.index <= 8) {
                            doc.setDrawColor(0);
                            doc.setLineWidth(1);
                            doc.line(cell.x, cell.y, cell.x + cell.width, cell.y); // draw line above the cell
                        }
                    }
                },

                didDrawPage: function (data) {
                    if (data.pageNumber > 1) {
                        addHeader(doc, companyData, siteData, documentDetails, xLeftKey, xRightKey, pageWidth, doc.internal.getNumberOfPages(), totalPagesExp);
                    }
                    addFooter(doc, pageWidth, pageHeight);
                },
            });

            //doc.line(xLeftKey, 305, pageWidth - 35, 305);

            finalY = doc.lastAutoTable.finalY + 30;

            // calculate space needed for VAT section (title + table + footer)
            const vatTitleHeight = 20;
            const vatTableHeight = 50; // height of the VAT table
            const footerHeight = 55;
            const spaceNeeded = vatTitleHeight + vatTableHeight + footerHeight;

            // only add new page if there's not enough space
            if (finalY + spaceNeeded > pageHeight) {
                doc.addPage();
                addHeader(doc, companyData, siteData, documentDetails, xLeftKey, xRightKey, pageWidth, doc.internal.getNumberOfPages(), totalPagesExp);
                finalY = 100;
            }

            let vatableSales = summaryData.net_amount
            let vatAmount = '0.00'
            let vatIdentifier = ''

            if (documentDetails.party_tax_type == 'V') {
                vatableSales = summaryData.vatables
                vatAmount = summaryData.vat_amount
                vatIdentifier = 'Vat 12'

            } else if (documentDetails.party_tax_type == 'X') {
                vatIdentifier = 'Vat EX'
            } else if (documentDetails.party_tax_type == 'Z') {
                vatIdentifier = 'Vat 0'
            }
            // note:  to be checked w/ primer

            const vatColumns = [
                { header: 'VAT Identifier', dataKey: 'vat_identifier', styles: { cellWidth: 65, halign: 'left' } },
                { header: 'VAT %', dataKey: 'vat', styles: { cellWidth: 65, halign: 'right' } },
                { header: 'Line Amount', dataKey: 'subtotal', styles: { cellWidth: 65, halign: 'right' } },
                { header: 'Invoice Discount Base Amount', dataKey: 'subtotal', styles: { cellWidth: 65, halign: 'right' } },
                { header: 'Invoice Discount Amount', dataKey: 'invoice_discount_amount', styles: { cellWidth: 65, halign: 'right' } },
                { header: 'VAT Base', dataKey: 'vat_base', styles: { cellWidth: 65, halign: 'right' } },
                { header: 'VAT Amount', dataKey: 'vat_amount', styles: { cellWidth: 65, halign: 'right', fontSize: 8 } },
            ];
            let subtotal = Number(totalLineAmount)

            const extractedVatData = [
                {
                    vat_identifier: vatIdentifier.toUpperCase(),
                    vat: (documentDetails.party_tax_type == 'V') ? '12' : '0.00',
                    line_amount: `${Number(subtotal).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`,
                    invoice_discount_base_amount: `${Number(subtotal).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`,
                    invoice_discount_amount: `${(Number(documentDetails.amount_header_discount) + Number(documentDetails.trade_discount)).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`,
                    vat_base: `${Number(vatableSales).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`,
                    vat_amount: `${Number(vatAmount).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`
                },
                {

                    vat_identifier: { content: 'Total', styles: { fontStyle: 'bold' } },
                    vat: (documentDetails.party_tax_type == 'V') ? '12' : '0.00',
                    line_amount: {
                        content: `${Number(subtotal).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`, styles: { fontStyle: 'bold' }
                    },
                    invoice_discount_base_amount: {
                        content: `${Number(subtotal).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`, styles: { fontStyle: 'bold' }
                    },
                    invoice_discount_amount: {
                        content: `${(Number(documentDetails.amount_header_discount) + Number(documentDetails.trade_discount)).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`, styles: { fontStyle: 'bold' }
                    },
                    vat_base: {
                        content: `${Number(vatableSales).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`, styles: { fontStyle: 'bold' }
                    },
                    vat_amount: {
                        content: `${Number(vatAmount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`, styles: { fontStyle: 'bold' }
                    },
                }
            ];

            // VAT Amount Specification title
            doc.setFontStyle("bold");
            doc.text("VAT Amount Specification", 35, finalY);
            finalY += vatTitleHeight;

            // VAT Table
            doc.autoTable({
                theme: 'plain',
                head: [vatColumns.map(col => col.header)],
                body: extractedVatData.map(row => Object.values(row)),
                startY: finalY,
                styles: {
                    fontSize: 7,
                    cellPadding: 2.2,
                    overflow: 'lineBreak'
                },
                margin: { left: 35, right: 35, top: 100, bottom: 58 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' },
                bodyStyles: { halign: 'right', valign: 'middle' },
                columnStyles: {
                    0: { halign: 'center' }, // VAT Identifier
                    1: { halign: 'right' }, // VAT
                    2: { halign: 'right' }, // Line Amount
                    3: { halign: 'right' }, // Invoice Discount Base Amount
                    4: { halign: 'right' }, // Invoice Discount Amount
                    5: { halign: 'right' }, // VAT Base
                    6: { halign: 'right' }, // VAT Amount
                },
                tableLineColor: [0, 0, 0],
                tableLineWidth: 1,
                pageBreak: 'auto',

                didDrawCell: function (data) {
                    const { column, row, table, cell } = data;

                    // draw header line
                    if (row.section === 'head' && column.index >= 0 && column.index <= 6) {
                        doc.setDrawColor(0);
                        doc.setLineWidth(1);
                        doc.line(cell.x, cell.y + cell.height, cell.x + cell.width, cell.y + cell.height);
                    }

                    // draw separation line above the 'Total' row
                    const isTotalRow = row.raw[0] === 'Total';
                    if (isTotalRow && column.index >= 2 && column.index <= 6) {
                        doc.setDrawColor(0);
                        doc.setLineWidth(1);
                        doc.line(cell.x, cell.y, cell.x + cell.width, cell.y); // draw line above the cell
                    }
                },

                didDrawPage: function (data) {
                    if (data.pageNumber > 1) {
                        addHeader(doc, companyData, siteData, documentDetails, xLeftKey, xRightKey, pageWidth, doc.internal.getNumberOfPages(), totalPagesExp);
                    }
                    addFooter(doc, pageWidth, pageHeight);
                },
            });

            addFooter(doc, pageWidth, pageHeight);

            if (typeof doc.putTotalPages === 'function') {
                doc.putTotalPages(totalPagesExp);
            }

            this.spinning = false
            //doc.save(`CAS-${handleNull(documentDetails.cas_no)}.pdf`);
            let pdfWindow = window.open(doc.output('bloburl'), '_blank');
            // Add manual print trigger button
            const detectBrowser = () => {
                const agent = window.navigator.userAgent.toLowerCase();
                if (agent.indexOf('edg') > -1) return 'Microsoft Edge';
                if (agent.indexOf('chrome') > -1) return 'Google Chrome';
                if (agent.indexOf('safari') > -1) return 'Safari';
                return 'Not Supported Browser';
            };

            const detectColorScheme = () => {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    return 'dark';
                }
                return 'light';
            };

            const browserName = detectBrowser();
            const colorScheme = detectColorScheme();
            const browserColors = {
                'Google Chrome': {
                    dark: 'rgb(51, 54, 57)',
                    light: 'white'
                },
                'Microsoft Edge': {
                    dark: 'rgb(59, 59, 59)',
                    light: 'rgb(247, 247, 247)'
                },
                'Safari': {
                    dark: 'rgb(44, 44, 44)',
                    light: 'white'
                },
                'default': {
                    dark: 'rgb(30, 33, 36)',
                    light: 'white'
                }
            };
            const getBackgroundColor = () => {
                const browserColorConfig = browserColors[browserName] || browserColors['default'];
                return browserColorConfig[colorScheme];
            };

            if (!isPrinted) {
                pdfWindow.addEventListener('load', () => {
                    const printButton = pdfWindow.document.createElement('button');
                    printButton.style.position = 'fixed';
                    printButton.style.top = browserName == 'Microsoft Edge' ? '2px' : '10px';
                    printButton.style.right = '10px';
                    printButton.style.zIndex = '9999';
                    printButton.style.marginRight = '44px';
                    printButton.style.backgroundColor = getBackgroundColor();
                    printButton.style.border = 'none';
                    printButton.style.padding = browserName == 'Microsoft Edge' ? '10px 40px' : '10px 20px';
                    printButton.style.cursor = 'pointer';
                    printButton.style.color = colorScheme == 'dark' ? 'white' : 'black'
                    printButton.style.fontSize = '15px'

                    const fontAwesomeLink = pdfWindow.document.createElement('link');
                    fontAwesomeLink.rel = 'stylesheet';
                    fontAwesomeLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
                    pdfWindow.document.head.appendChild(fontAwesomeLink);

                    printButton.innerHTML = '<i class="fas fa-print"></i> Print';

                    printButton.addEventListener('click', () => {
                        pdfWindow.print()
                        this.create_action_history('Print Document', documentDetails.id)
                    });
                    pdfWindow.document.body.appendChild(printButton);
                });
            }
        },
        async create_action_history(action, doc_no) {
            var actionHistoryPayload = {
                action: action,
                action_at: moment(new Date()),
                action_by: secureStorage.getItem("userName"),
                document_id: doc_no,
                status: "A"
            }
            await HTTPRequest.postRequest(this.endPoint + 'document_action_histories/', null, actionHistoryPayload)
        },
    },
};

export default printReccsr;
